import Form from 'components/Form';
import {
  Box,
  TableBody,
  TableHead,
  TableRow,
  TableContainer,
} from '@mui/material';
import {
  StyledTableCellTwo,
  StyledTableCellWithoutLeftTwo,
} from 'routes/Main/style';
import SectionTitle from '../../components/SectionTitle';

import { IFormValues, IFormWatch, IFormRegister } from 'routes/Main/type';

const contentLabel = [
  {
    id: 1,
    ko: '호흡',
    desc: '정상',
    desc1: '간헐적 힘든 호흡, 짧은 과환기',
    desc2: '시끄럽고 힘든 호흡, 긴 과호흡, 체인-스콕스 호흡 ',
    keyName: 'respiration',
  },
  {
    id: 2,
    ko: '소리냄',
    desc: '없음',
    desc1: '간헐적인 신음, 부정적이거나 못마땅한 낮은 음성',
    desc2: '반복적인 괴로운 소리 지름, 큰 소리로 신음함, 울음',
    keyName: 'shout',
  },
  {
    id: 3,
    ko: '얼굴표정',
    desc: '웃거나 무표정',
    desc1: '슬픈 표정, 두려운 표정, 눈살을 찌푸리는 표정',
    desc2: '찡그린 얼굴',
    keyName: 'face',
  },
  {
    id: 4,
    ko: '신체표현',
    desc: '이완됨',
    desc1: '긴장함, 고통스러운 걸음, 안절부절 못함',
    desc2:
      '경직됨, 주먹을 꽉 쥠, 무릎을 당겨 웅크림, 상대를 당기거나 밈, 공격함',
    keyName: 'body',
  },
  {
    id: 5,
    ko: '마음의 안정도',
    desc: '위로할 필요없음',
    desc1: '목소리나 가벼운 접촉에 의해 전환되거나 진정됨',
    desc2: '위로, 전환, 진정시킬 수 없음',
    keyName: 'mind',
  },
  {
    id: 6,
    ko: '총점',
    desc: '',
    desc1: '',
    desc2: '',
    keyName: '',
  },
];

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
}
const PAINADK = (props: Props) => {
  const { disabled, setValue, getValues, register, watch } = props;

  const 호흡01 = props.watch('respiration01')
    ? Number(props.watch('respiration01'))
    : 0;
  const 소리01 = props.watch('shout01') ? Number(props.watch('shout01')) : 0;
  const 얼굴01 = props.watch('face01') ? Number(props.watch('face01')) : 0;
  const 신체01 = props.watch('body01') ? Number(props.watch('body01')) : 0;
  const 마음01 = props.watch('mind01') ? Number(props.watch('mind01')) : 0;

  const 호흡02 = props.watch('respiration02')
    ? Number(props.watch('respiration02'))
    : 0;
  const 소리02 = props.watch('shout02') ? Number(props.watch('shout02')) : 0;
  const 얼굴02 = props.watch('face02') ? Number(props.watch('face02')) : 0;
  const 신체02 = props.watch('body02') ? Number(props.watch('body02')) : 0;
  const 마음02 = props.watch('mind02') ? Number(props.watch('mind02')) : 0;

  const 호흡03 = props.watch('respiration03')
    ? Number(props.watch('respiration03'))
    : 0;
  const 소리03 = props.watch('shout03') ? Number(props.watch('shout03')) : 0;
  const 얼굴03 = props.watch('face03') ? Number(props.watch('face03')) : 0;
  const 신체03 = props.watch('body03') ? Number(props.watch('body03')) : 0;
  const 마음03 = props.watch('mind03') ? Number(props.watch('mind03')) : 0;

  const 총점1 = 호흡01 + 소리01 + 얼굴01 + 신체01 + 마음01;

  const 총점2 = 호흡02 + 소리02 + 얼굴02 + 신체02 + 마음02;

  const 총점3 = 호흡03 + 소리03 + 얼굴03 + 신체03 + 마음03;

  return (
    <>
      <SectionTitle title="PAINAD-K" mt={3} mb={2} />
      <Box sx={{ width: '98%', margin: '20px' }}>
        <TableContainer>
          <TableHead>
            <TableRow>
              <StyledTableCellTwo
                colSpan={1}
                sx={{
                  padding: '16px',
                  borderTop: '1px solid lightgray',
                  fontSize: '12px',
                }}
              >
                행동
              </StyledTableCellTwo>
              <StyledTableCellTwo
                colSpan={1}
                sx={{ borderTop: '1px solid lightgray', fontSize: '12px' }}
              >
                0점
              </StyledTableCellTwo>
              <StyledTableCellTwo
                colSpan={1}
                sx={{
                  borderTop: '1px solid lightgray',
                  fontSize: '12px',
                }}
              >
                1점
              </StyledTableCellTwo>
              <StyledTableCellTwo
                colSpan={1}
                sx={{
                  borderTop: '1px solid lightgray',
                  fontSize: '12px',
                }}
              >
                2점
              </StyledTableCellTwo>
              <StyledTableCellTwo
                colSpan={1}
                align="center"
                sx={{
                  borderTop: '1px solid lightgray',
                  paddingLeft: '30px',
                  fontSize: '12px',
                  fontWeight: 500,
                }}
              >
                입실
                <br />
                5분이내
              </StyledTableCellTwo>
              <StyledTableCellTwo
                colSpan={1}
                align="center"
                sx={{
                  borderTop: '1px solid lightgray',
                  fontSize: '12px',
                  fontWeight: 500,
                }}
              >
                입실
                <br />
                5분이후
              </StyledTableCellTwo>
              <StyledTableCellTwo
                colSpan={1}
                align="center"
                sx={{
                  borderTop: '1px solid lightgray',
                  fontSize: '12px',
                  fontWeight: 500,
                }}
              >
                입실 or
                <br />
                중재
                <br />
                30분후
              </StyledTableCellTwo>
            </TableRow>
          </TableHead>

          <TableBody>
            {contentLabel.map(
              (
                content: {
                  id: number;
                  ko: string;
                  desc: string;
                  desc1: string;
                  desc2: string;
                  keyName: string;
                },
                i
              ) => {
                if (content.ko === '총점') {
                  return (
                    <TableRow>
                      <StyledTableCellTwo
                        align="left"
                        sx={{
                          padding: '16px',
                          width: '150px',
                          whiteSpace: 'nowrap',
                          fontSize: '12px',
                        }}
                      >
                        {content.ko}
                      </StyledTableCellTwo>
                      <StyledTableCellTwo
                        align="left"
                        sx={{
                          width: '1000px',
                          whiteSpace: 'nowrap',
                          fontSize: '12px',
                        }}
                      >
                        {content.desc}
                      </StyledTableCellTwo>
                      <StyledTableCellTwo
                        align="left"
                        sx={{
                          width: '1000px',
                          whiteSpace: 'nowrap',
                          fontSize: '12px',
                        }}
                      >
                        {content.desc1}
                      </StyledTableCellTwo>
                      <StyledTableCellTwo
                        align="left"
                        sx={{
                          width: '1000px',
                          whiteSpace: 'nowrap',
                          fontSize: '12px',
                        }}
                      >
                        {content.desc2}
                      </StyledTableCellTwo>
                      <StyledTableCellWithoutLeftTwo>
                        <Form.MuiTextField
                          disabled={disabled}
                          sx={{ width: '80px', marginLeft: '30px' }}
                          value={총점1}
                        />
                      </StyledTableCellWithoutLeftTwo>
                      <StyledTableCellWithoutLeftTwo>
                        <Form.MuiTextField
                          disabled={disabled}
                          sx={{ width: '80px', margin: '0 30px 0 30px' }}
                          value={총점2}
                        />
                      </StyledTableCellWithoutLeftTwo>
                      <StyledTableCellWithoutLeftTwo>
                        <Form.MuiTextField
                          disabled={disabled}
                          sx={{ width: '80px' }}
                          value={총점3}
                        />
                      </StyledTableCellWithoutLeftTwo>
                    </TableRow>
                  );
                }

                return (
                  <TableRow>
                    <StyledTableCellTwo
                      align="left"
                      sx={{
                        padding: '16px',
                        width: '150px',
                        whiteSpace: 'nowrap',
                        fontSize: '12px',
                      }}
                    >
                      {content.ko}
                    </StyledTableCellTwo>
                    <StyledTableCellTwo
                      align="left"
                      sx={{
                        width: '150px',
                        whiteSpace: 'nowrap',
                        fontSize: '12px',
                      }}
                    >
                      {content.desc}
                    </StyledTableCellTwo>
                    <StyledTableCellTwo
                      align="left"
                      sx={{
                        width: '270px',
                        whiteSpace: 'nowrap',
                        fontSize: '12px',
                      }}
                    >
                      {content.desc1}
                    </StyledTableCellTwo>
                    <StyledTableCellTwo
                      align="left"
                      sx={{
                        width: '540px',
                        whiteSpace: 'nowrap',
                        fontSize: '12px',
                      }}
                    >
                      {content.desc2}
                    </StyledTableCellTwo>
                    <StyledTableCellWithoutLeftTwo>
                      <Form.MuiTextField
                        required={false}
                        disabled={disabled}
                        sx={{ width: '80px', marginLeft: '30px' }}
                        type="number"
                        {...register(`${content.keyName}01`, {
                          onChange: e => {
                            if (e.target.value > 2) {
                              alert('0-2까지 입력할 수 있습니다.');
                              setValue(`${content.keyName}01`, 0);
                            }
                            if (e.target.value < 0) {
                              alert('음수는 불가능합니다.');
                              setValue(`${content.keyName}01`, 0);
                            }
                            setValue(
                              `${content.keyName}01`,
                              Number(e.target.value)
                            );
                          },
                        })}
                      />
                    </StyledTableCellWithoutLeftTwo>
                    <StyledTableCellWithoutLeftTwo>
                      <Form.MuiTextField
                        required={false}
                        disabled={disabled}
                        sx={{ width: '80px', margin: '0 30px 0 30px' }}
                        type="number"
                        {...register(`${content.keyName}02`, {
                          onChange: e => {
                            if (e.target.value > 2) {
                              alert('0-2까지 입력할 수 있습니다.');
                              setValue(`${content.keyName}02`, 0);
                            }
                            if (e.target.value < 0) {
                              alert('음수는 불가능합니다.');
                              setValue(`${content.keyName}02`, 0);
                            }
                            setValue(
                              `${content.keyName}02`,
                              Number(e.target.value)
                            );
                          },
                        })}
                      />
                    </StyledTableCellWithoutLeftTwo>
                    <StyledTableCellWithoutLeftTwo>
                      <Form.MuiTextField
                        required={false}
                        disabled={disabled}
                        sx={{ width: '80px' }}
                        type="number"
                        {...register(`${content.keyName}03`, {
                          onChange: e => {
                            if (e.target.value > 2) {
                              alert('0-2까지 입력할 수 있습니다.');
                              setValue(`${content.keyName}03`, 0);
                            }
                            if (e.target.value < 0) {
                              alert('음수는 불가능합니다.');
                              setValue(`${content.keyName}03`, 0);
                            }
                            setValue(
                              `${content.keyName}03`,
                              Number(e.target.value)
                            );
                          },
                        })}
                      />
                    </StyledTableCellWithoutLeftTwo>
                  </TableRow>
                );
              }
            )}
          </TableBody>
        </TableContainer>
      </Box>
    </>
  );
};

export default PAINADK;
